import React from "react";
// import { breadcrumbs } from "../../common/breadcrumbs";
// import { TopBanner } from "../../common/TopBanner";
import { getUrl } from "../../lib/masterUtil";
import { Link } from "../../lib/Link";
import { area_selector } from "../../common/area_selector";

export const search_campaign = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜キャンペーン';
  return (
    <div className="container">
      <main className="search_campaign">
        <section className="mv">
          <h1>
            <span className="mv_sp">
              <img
                src="resource/img/static/search_campaign/sp-mv_01.png?201812"
                width="90"
                height="87"
                className="mv01"
                alt="今がチャンス！"
              />
              <img
                src="resource/img/static/search_campaign/sp-mv_02.png?201812"
                width="227"
                height="63"
                className="mv02"
                alt="初めての方も・リピーターの方も"
              />
              <img
                src="resource/img/static/search_campaign/sp-mv_03.png?201812"
                width="277"
                height="104"
                className="mv03"
                alt="お得なキャンペーン"
              />
            </span>
            <span className="mv_pc">
              <img
                src="resource/img/static/search_campaign/pc-mv_01.png?201812"
                className="mv01"
                alt="今がチャンス！"
              />
              <img
                src="resource/img/static/search_campaign/pc-mv_02.png?201812"
                className="mv02"
                alt="初めての方も・リピーターの方も"
              />
              <img
                src="resource/img/static/search_campaign/pc-mv_03.png?201812"
                className="mv03"
                alt="お得なキャンペーン"
              />
            </span>
          </h1>
        </section>
        <div>
          <p className="notes">
            ※すべてのキャンペーンは<br />他のキャンペーンとの併用は不可です。
          </p>
        </div>
        <section className="contents contents_1">
          <h2 className="contents_title">
            事務手数料<br className="hidden" />
            <strong className="price">0<span>円</span></strong><br className="hidden" />
            <strong>キャンペーン！</strong>
          </h2>
          <div className="contents_box">
            <p className="paragraph">
              事務手数料が<br className="hidden" />
              <strong className="paragraph_bg">無料</strong>
            </p>
            <p className="paragraph_sub">さらに、</p>
            <p className="paragraph">
              使用料が<br className="hidden" />
              <strong className="paragraph_bg"><span className="month">6</span><span className="small">ヶ月</span>半額</strong>
            </p>
            <Link
              to={getUrl({ condition: { campaign: ["premire0"] } })}
              className="btn_campaign"
            >
              <i className="icon"></i>
              物件一覧を見る
            </Link>
          </div>
        </section>
        <div className="flex_container">
          <section className="contents contents_2">
            <h2 className="contents_title">
              物件まるごと
              <strong>お得！</strong>
            </h2>
            <div className="contents_wrap">
              <div className="contents_box">
                <p className="paragraph">
                  使用料が<br/>
                  <strong className="paragraph_bg"><span className="month">6</span><span className="small">ヶ月</span>半額</strong>
                </p>
                <Link
                  to={getUrl({ condition: { campaign: ["super6m"] } })}
                  className="btn_campaign"
                >
                  <i className="icon"></i>
                  物件一覧を見る
                </Link>
              </div>
              <div className="contents_box">
                <p className="paragraph">
                  使用料が<br/>
                  <strong className="paragraph_bg"><span className="month">3</span><span className="small">ヶ月</span>半額</strong>
                </p>
                <Link
                  to={getUrl({ condition: { campaign: ["super3m"] } })}
                  className="btn_campaign"
                >
                  <i className="icon"></i>
                  物件一覧を見る
                </Link>
              </div>
            </div>
          </section>
          <section className="contents contents_3">
            <h2 className="contents_title">
              限定部屋が
              <strong>お得！</strong>
            </h2>
            <div className="contents_box">
              <p className="paragraph">
                使用料が<br/>
                <strong className="paragraph_bg"><span className="month">6</span><span className="small">ヶ月</span>半額</strong>
                <Link
                  to={getUrl({ condition: { campaign: ["medama6m"] } })}
                  className="btn_campaign"
                >
                  <i className="icon"></i>
                  物件一覧を見る
                </Link>
              </p>
            </div>
          </section>
        </div>
        <div className="btn_wrap">
          <Link
            to={getUrl({ condition: { campaign: 1 } })}
            className="btn_campaign"
          >
            すべてのキャンペーンから探す
          </Link>
        </div>
        <section className="search">
          <h3 className="search_title"><i className="icon"></i>キャンペーン適用物件の検索</h3>
          <p className="pc">お探しの都道府県を選択してください。</p>
          {area_selector(type, { condition: { campaign: 1 } })}
        </section>
      </main>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/search_campaign.jsx